// extracted by mini-css-extract-plugin
module.exports = {"ColorLimit":"limit_ColorLimit__3YbR3"};